module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ARrkB/tc-custom/9780062305589.jpg?1728259255722",
      "alt": "This image is the cover for the book Imagine"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Imagine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The polar ice caps are melting, hurricanes and droughts ravish the planet, and the earth's population is threatened by catastrophic climate change. Millions of American jobs have been sent overseas and aren't coming back. Young African-American men make up the majority of America's prison population. Half of the American population are poor or near poor, living precariously on the brink, while the top one percent own as much as the bottom eighty. Government police-state spying on its citizens is pervasive. Consequently, as former President Jimmy Carter has said, \"we have no functioning democracy.\"")]), _c('p', [_c('i', [_vm._v("Imagine: Living In a Socialist U.S.A.")]), _vm._v(", edited by Francis Goldin, Debby Smith, and Michael Steven Smith, is at once an indictment of American capitalism as the root cause of our spreading dystopia and a cri de coeur for what life could be like in the United States if we had economic as well as a real political democracy. This anthology features essays by revolutionary thinkers, activists, and artists—including Academy Award-winning filmmaker Michael Moore, civil rights activist Angela Davis, incarcerated journalist Mumia Abu Jamal, and economist Rick Wolff— addressing various aspects of a new society and, crucially, how to get from where we are now to where we want to be, living in a society that is truly fair and just.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frances Goldin, Debby Smith\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publisher\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0